import { Header } from "../components/Header";
import { NavBar } from "../components/items/NavBar";
import { Skills } from "../components/sections/Skills";

import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/Footer";
import { Portfolio } from "../components/sections/Portfolio";
import { useRef } from "react";

export function Home(): JSX.Element {
  const contactRef = useRef<HTMLDivElement>(null);
  const portfolioRef = useRef<HTMLDivElement>(null);
  const skillsRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  function scrollToElement(element: React.RefObject<HTMLDivElement>): void {
    element.current?.scrollIntoView({ behavior: "smooth" });
  }
  return (
    <div id="page-auth" className="page-auth">
      <NavBar
        contactRef={contactRef}
        portfolioRef={portfolioRef}
        skillsRef={skillsRef}
        headerRef={headerRef}
      />
      <Header ref={headerRef} />
      <Skills ref={skillsRef} />
      <Portfolio ref={portfolioRef} />
      <Contact ref={contactRef} />
      <Footer scrollToTop={() => scrollToElement(headerRef)} />
    </div>
  );
}
